// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2554 ? "effa34c9" : chunkId) + "." + {"2554":"1998676e59b8d24f","3813":"86370b0e72ff770c","3909":"e2597a374934cc48"}[chunkId] + ".js";
};